<div class="container pt-5">
    <div class="row">
        <div class="col col-md-8">
            
            <h3 class="h4">
                Manage dropdown hierarchy
            </h3>
            <p class="text-muted">Shown below is the current hierarchy of dropdown menus for the <strong>Map Dashboard</strong> page. Create and update <em>paths</em> through the menus by selecting the desired sequence below.</p>
            
            <div class="row">
                <div class="col mt-4">
                    <dropdownhierarchyitem *ngIf="dropdownHieararchy" [(dropDownHieararchy)]="dropdownHieararchy" [availableDropDowns]="availableDropDowns"></dropdownhierarchyitem>
                </div>
            </div>
        </div>
        <div class="col col-md-4">
           <button class="btn btn-sm btn-primary pull-right" (click)="onSave()">Save changes<i class="fa fa-check ml-3"></i></button>
        </div>
    </div>
</div>

<confirmationmodal #confirmModal [confirmationText]="'Please note that if you have removed any drop downs from the hierarchy this may result in the loss of map content. Are you sure you want to continue?'" (onAccept)="onAccept();"></confirmationmodal>